import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-moreinfo',
  templateUrl: './moreinfo.component.html',
  styleUrls: ['./moreinfo.component.css']
})
export class MoreinfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
